import { render, staticRenderFns } from "./ModalRC.vue?vue&type=template&id=259ebd0a&"
import script from "./ModalRC.vue?vue&type=script&lang=js&"
export * from "./ModalRC.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports